var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import { DATE_DAY } from '../constants';
import * as rawJSONSchemaModuleObstetrics from '../../schemas/module-obstetrics.json';
var ModuleValueObstetrics = (function (_super) {
    __extends(ModuleValueObstetrics, _super);
    function ModuleValueObstetrics() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueObstetrics;
}(ModuleValueGeneral));
var SchemaModuleObstetrics = (function (_super) {
    __extends(SchemaModuleObstetrics, _super);
    function SchemaModuleObstetrics() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleObstetrics);
        return _this;
    }
    SchemaModuleObstetrics.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
        this.listenValue('edd_compute', this.fieldHandlerEDDCompute.bind(this));
        this.listenValue(['lmp', 'edd'], this.fieldHandlerLMPEDD.bind(this));
        this.listenValue(['lmp', 'date_of_delivery'], this.fieldHandlerGestationPeriod('gestation_period_days').bind(this));
        this.listenValue(['lmp', 'date_of_obstetrics_procedure'], this.fieldHandlerGestationPeriod('obstetrics_procedure_gestation_period_days').bind(this));
        this.listenValue(['discharge_date', 'date_of_delivery'], this.fieldHandlerDischargeDate('length_of_stay').bind(this));
        this.listenValue('lactate_mg_dl_compute', this.fieldHandlerLactateCompute('lactate_mg_dl_compute', 'lactate_mmol_l', 'lactate_mg_dl').bind(this));
        this.listenValue(['lactate_mmol_l', 'lactate_mg_dl'], this.fieldHandlerLactate('lactate_mg_dl_compute', 'lactate_mmol_l', 'lactate_mg_dl').bind(this));
        this.listenValue('cord_lactate_mg_dl_compute', this.fieldHandlerLactateCompute('cord_lactate_mg_dl_compute', 'cord_lactate_mmol_l', 'cord_lactate_mg_dl').bind(this));
        this.listenValue(['cord_lactate_mmol_l', 'cord_lactate_mg_dl'], this.fieldHandlerLactate('cord_lactate_mg_dl_compute', 'cord_lactate_mmol_l', 'cord_lactate_mg_dl').bind(this));
    };
    SchemaModuleObstetrics.prototype.fieldHandlerEDDCompute = function (compute) {
        if (typeof compute === 'undefined' || compute === null)
            return;
        this.schema.properties['edd'].readOnly = compute;
        this.schema.properties['lmp'].readOnly = !compute;
        this.fieldHandlerLMPEDD(this.getValue('lmp'), this.getValue('edd'));
    };
    SchemaModuleObstetrics.prototype.fieldHandlerLMPEDD = function (lmpString, eddString) {
        if (this.getValue('edd_compute')) {
            this.calculateEDD(lmpString);
        }
        else {
            this.calculateLMP(eddString);
        }
    };
    SchemaModuleObstetrics.prototype.calculateEDD = function (lmpString) {
        var edd = new Date(lmpString);
        edd = this.modifyDate(edd, DATE_DAY * 280);
        var eddString = this.getShortDate(edd);
        this.updateValue('edd', eddString || '');
    };
    SchemaModuleObstetrics.prototype.calculateLMP = function (eddString) {
        var lmp = new Date(eddString);
        lmp = this.modifyDate(lmp, -DATE_DAY * 280);
        var lmpString = this.getShortDate(lmp);
        this.updateValue('lmp', lmpString || '');
    };
    SchemaModuleObstetrics.prototype.modifyDate = function (date, change) {
        if (date && isNaN(date.valueOf()))
            return null;
        return new Date(date.valueOf() + change);
    };
    SchemaModuleObstetrics.prototype.getShortDate = function (date) {
        return (date && !isNaN(date.valueOf())) ? date.toISOString().split('T')[0] : null;
    };
    SchemaModuleObstetrics.prototype.fieldHandlerGestationPeriod = function (gestationPeriodProperty) {
        var _this = this;
        return function (lmpString, deliveryDateString) {
            var value = _this.calculateGestationDays(lmpString, deliveryDateString);
            _this.updateValue(gestationPeriodProperty, value);
        };
    };
    SchemaModuleObstetrics.prototype.calculateGestationDays = function (lmpString, deliveryDateString) {
        var lmp = new Date(lmpString);
        var deliveryDate = new Date(deliveryDateString);
        var gestation_days = Math.ceil((deliveryDate.valueOf() - lmp.valueOf()) / DATE_DAY);
        if (isNaN(gestation_days) || gestation_days < 0) {
            gestation_days = null;
        }
        return gestation_days;
    };
    SchemaModuleObstetrics.prototype.fieldHandlerLactateCompute = function (computeProperty, mmolLProperty, mgdLProperty) {
        var _this = this;
        return function (compute) {
            if (typeof compute === 'undefined' || compute === null)
                return;
            _this.schema.properties[mgdLProperty].readOnly = compute;
            _this.schema.properties[mmolLProperty].readOnly = !compute;
            _this.fieldHandlerLactate(computeProperty, mmolLProperty, mgdLProperty)(_this.getValue(mmolLProperty), _this.getValue(mgdLProperty));
        };
    };
    SchemaModuleObstetrics.prototype.fieldHandlerLactate = function (computeProperty, mmolLProperty, mgdLProperty) {
        var _this = this;
        return function (mmolL, mgdL) {
            // mgdL = mmolL * 18;
            if (_this.getValue(computeProperty)) {
                _this.updateValue(mgdLProperty, (mmolL === null ? null : mmolL * 18));
            }
            else {
                _this.updateValue(mmolLProperty, (mgdL === null ? null : mgdL / 18));
            }
        };
    };
    SchemaModuleObstetrics.prototype.setupValidators = function () {
        _super.prototype.setupValidators.call(this);
        this.validatorDateComparison('date_of_delivery', 'lmp', '>');
        this.validatorDateComparison('date_of_obstetrics_procedure', 'lmp', '>');
        this.validatorDateComparison('discharge_date', 'lmp', '>');
        this.validatorDateComparison('discharge_date', 'date_of_delivery', '>=');
        this.validatorDate('date_of_birth', (new Date()), '<=', function (v) { return new Date(v); });
    };
    return SchemaModuleObstetrics;
}(SchemaModuleGeneral));
export { SchemaModuleObstetrics };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-obstetrics.ts.pre-build-optimizer.js